








import Vue from 'vue'
import { Toast } from 'vuex-toast'
import PaymentModal from '@/layout/parts/PaymentModal.vue'
import TariffsModal from '@/layout/parts/TariffsModal.vue'

export default Vue.extend({
  components: {
    Toast,
    PaymentModal,
    TariffsModal,
  },
  computed: {
    activeCompanyId(): string {
      return String(this.$store.getters.getActiveCompany?.id ?? '-1')
    },
  },
})
